import React from "react";
import "./IconBulletList.css";
import { Headline, Paragraph, Section, ContentBlock, Icon } from "./ui";

const IconBulletList = ({
  items = [],
  icon = "check",
  headline = null,
  headlineIcon = null,
  highlightedIndices = [],
  variant = "transparent",
  spacing = "none",
  maxWidth = "4xl",
  className = "",
  margin = true,
}) => {
  return (
    <Section
      variant={variant}
      spacing={spacing}
      className={className}
      margin={margin}
    >
      <ContentBlock
        maxWidth={maxWidth}
        spacing="comfortable"
        className="mx-auto"
      >
        {headline && (
          <div className="flex items-center gap-4 ">
            {headlineIcon && (
              <img
                src={`${process.env.PUBLIC_URL}/${headlineIcon}`}
                alt="Headline icon"
                className="w-12 h-12 flex-shrink-0"
              />
            )}
            <Headline variant="h2" color="secondary" className="pb-6">
              {headline}
            </Headline>
          </div>
        )}

        <ul className="space-y-4">
          {items.map((item, index) => {
            const isHighlighted = highlightedIndices.includes(index);
            return (
              <li
                key={index}
                className={`flex items-center gap-3 p-4 sm:p-8 rounded-sm max-w-4xl ${
                  isHighlighted ? "border-2 border-dotted border-green-400" : ""
                }`}
                style={{ backgroundColor: "var(--color-primary-contrast)" }}
              >
                <Icon
                  name={icon}
                  size="md"
                  className="text-[var(--color-secondary)] flex-shrink-0 mr-4"
                />
                <Paragraph
                  variant="large"
                  color="secondary"
                  noSpacing
                  className={isHighlighted ? "font-bold" : ""}
                >
                  {item}
                </Paragraph>
              </li>
            );
          })}
        </ul>
      </ContentBlock>
    </Section>
  );
};

export default IconBulletList;
